<template>
  <div
    class="line"
    :style="{ paddingLeft: node.level * 22 + 'px' }"
    @click="node.select(!node.selected)"
    :class="{ active: node.selected }"
  >
    <span class="arrow" @click="node.toggle()">
      <sc-icon
        v-show="node.children.length > 0"
        :type="node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'"
      />
    </span>
    <span class="checkbox">
      <a-checkbox
        :checked="node.checked === 'yes'"
        :indeterminate="node.checked === 'half'"
        @click="node.check(node.checked !== 'yes')"
      />
    </span>
    <div class="title" v-if="menus.length === 0">
      <slot />
    </div>
    <a-dropdown :trigger="['contextmenu']" v-else>
      <div class="title">
        <slot />
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item
            @click="menu.handler"
            v-for="(menu, index) in menus"
            :key="index"
          >
            {{ menu.title }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {DataNode} from './TreeUtil';

export default defineComponent({
  name: 'ScTreeNode',
  props: {
    node: {
      type: Object as PropType<DataNode<any>>,
      required: true,
    },
    menus: {
      type: Array as PropType<Array<{ title: string; handler: () => void }>>,
      default: () => [],
    },
  },
});
</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  .arrow {
    width: 16px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
    margin-right: 6px;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.active {
    .title {
      background-color: #82c3ff;
    }
  }
}
</style>
